import CommonConstants from '@/common/CommonConstants'
import { Component, Vue } from 'vue-property-decorator'
import Cookies from 'js-cookie'
import JISTWEBSSORDRCTService from './JISTWEBSSORDRCTService'
import { isEmpty } from 'xe-utils'
@Component({
  name: 'JISTWEBSSORDRCT'
  })
export default class JISTWEBSSORDRCTController extends Vue {
  private jistwebssordrctService: JISTWEBSSORDRCTService =
    new JISTWEBSSORDRCTService()

  /**
   * 画面要素描画後処理
   */
  created() {
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const name = isEmpty(this.$route?.query?.NAME)
      ? null
      : String(this.$route?.query?.NAME)
    const owname = isEmpty(this.$route?.query?.OWNAME)
      ? null
      : String(this.$route?.query?.OWNAME)
    const namemm = isEmpty(this.$route?.query?.NAMEMM)
      ? null
      : String(this.$route?.query?.NAMEMM)
    const specCode = isEmpty(this.$route?.query?.SPECCODE)
      ? null
      : String(this.$route?.query?.SPECCODE)
    const compCode = isEmpty(this.$route?.query?.COMPCODE)
      ? null
      : String(this.$route?.query?.COMPCODE)
    const reasonCode = isEmpty(this.$route?.query?.REASONCODE)
      ? null
      : String(this.$route?.query?.REASONCODE)
    const juns = isEmpty(this.$route?.query?.JUNS)
      ? null
      : String(this.$route?.query?.JUNS)
    const just = isEmpty(this.$route?.query?.JUST)
      ? null
      : String(this.$route?.query?.JUST)

    if (name) {
      Cookies.set(CommonConstants.NAME, name)
    }
    if (owname) {
      Cookies.set(CommonConstants.OWNAME, owname)
    }
    if (namemm) {
      Cookies.set(CommonConstants.NAMEMM, namemm)
    }
    if (juns) {
      Cookies.set(CommonConstants.JUNS, juns)
    }
    const xsrfToken = Cookies.get('XSRF-TOKEN')
    this.jistwebssordrctService.callAPICAAA1016(
      specCode,
      compCode,
      reasonCode,
      juns,
      just,
      xsrfToken
    )
  }
}
